import profile from './profile';
import enterprise from './enterprise';

// Menu Items

export const menuItems = {
    items: [profile]
};
export const menuItems2 = {
    items: [enterprise]
};

// export default menuItems;
